'use client';

// =============================================================================
// PullIndicator — визуальный indicator поверх top чтобы юзер видел прогресс
// pull-to-refresh жеста. Показывает «↓ ОБНОВИТЬ» / «↻ ОТПУСТИ» в зависимости
// от того достиг ли он threshold'а, и spinner во время refresh'а.
// =============================================================================

import { Spinner } from './Spinner';

const THRESHOLD = 80;

export function PullIndicator({
  distance,
  active,
}: {
  distance: number;
  active: boolean;
}) {
  if (distance === 0 && !active) return null;

  const reached = distance >= THRESHOLD;
  const opacity = Math.min(1, distance / 60);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-40 flex justify-center pointer-events-none"
      style={{
        transform: `translateY(${active ? 24 : Math.min(40, distance / 2)}px)`,
        opacity: active ? 1 : opacity,
        transition: active ? 'transform 0.2s, opacity 0.2s' : 'none',
      }}
    >
      <div className="bg-bg-elev border border-line px-3 py-1.5 flex items-center gap-2">
        {active ? (
          <>
            <Spinner size={14} />
            <span className="font-mono text-[10px] text-text-tertiary tracking-[0.15em]">
              ОБНОВЛЕНИЕ…
            </span>
          </>
        ) : (
          <span
            className={`font-mono text-[10px] tracking-[0.15em] ${
              reached ? 'text-accent' : 'text-text-tertiary'
            }`}
          >
            {reached ? '↻ ОТПУСТИ ДЛЯ ОБНОВЛЕНИЯ' : '↓ ПОТЯНИ ВНИЗ'}
          </span>
        )}
      </div>
    </div>
  );
}
